module.exports = __webpack_public_path__ + "60561026a9099d191f1ab737d1e81d6e.svg";


//////////////////
// WEBPACK FOOTER
// ./assets/svg/header/dashboard.svg
// module id = 8Jtg
// module chunks = 11